if(_SCLayoutProducts === undefined){

    function SCLayoutProducts() {
        this.vendors=[]
    }

    var _SCLayoutProducts = {
        _:{
            selectors:{
                productBlock:".js-cart-product",
                productExternalBlock:".js-cart-product-external",

                quantityForm: '.js-product-row-qty-form',
                notOrderProduct: ".js-product-row-no-order",

                quantityImg: '.js-product-row-qty-img',
                quantityInput: '.js-product-row-qty-input',
                quantityMinusButton: '.js-product-row-qty-minus',
                quantityPlusButton: '.js-product-row-qty-plus',
                quantityPlusFakeButton: '.js-product-row-qty-plus-fake',

                //special Modal
                modalSlideNext:'.js-modal-slide-next',
                modalSlidePrev:'.js-modal-slide-prev',

                //--not use
                productTitle: '.js-cart-product-modal',
                productItemContainer: '.js-product-bloc',
                typeBlock:".js-type-product",
                typeBlock_title:".js-cart-product-title",
                typeBlock_products:".js-cart-product-content"
            },
            messages: {
                indispoDate: 'Ce chef ne sera pas disponible à la date demandée',
                /* pas utiliser sur SC */
                unvalidVendor: 'Vous ne pouvez pas commander les produits de plusieurs chefs en même temps.',
                unvalidFilters:"Afin de pouvoir commander ce plat, veuillez renseigner la date, l'heure et le lieu de livraison souhaités",
                /* pas utiliser dans le code */
                notdispoVendor:"Ce chef n'est pas disponible aux dates et heures demandées",
                submitFilters: 'Veuillez valider les filtres ci-dessus'
            },
            filtre: {zip:null ,departement:null ,deliveryType:null ,date:null,time:null ,datetime:null ,day:null},
            day_index: ["Dimanche","Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi"],
            months: ["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"]
        },
        emit:function(name){
            var colorBG = "#1e98ec"
            if(name==="productUnvalid"){
                colorBG = "red"
            }
            if(name==="productValid"){
                colorBG = "green"
            }
            console.log("%c→ EMIT SCLayoutProducts." + name,"background:"+colorBG+";color:#FFF")
            console.log({arguments})

            $(document).trigger('SCLayoutProducts.'+name,arguments);
        },
        //getter
        //--- get le champs input de la quantity pour la cart et la modal du produit
        //--- recuperation de l'element input du produit (card et modal)
        getProductQuantityInput: function (variant_id) {
            return $(this._.selectors.quantityInput + '[data-variant="' + variant_id + '"]');
        },
        getProductQuantityImg: function (variant_id) {
            return $(this._.selectors.quantityImg + '[data-variant="' + variant_id + '"]');
        },
        getProductQuantityMinus: function (variant_id) {

            return $(this._.selectors.quantityMinusButton + '[data-variant="' + variant_id + '"]');
        },
        getProductQuantityPlus: function (variant_id) {

            return $(this._.selectors.quantityPlusButton + '[data-variant="' + variant_id + '"]');
        },
        getProductContainer: function (variant_id) {
            return $(this._.selectors.productItemContainer + '[data-variant="' + variant_id + '"]');
        },


        //--- recuperer l'interval du produit si existe
        getProductInterval: function(variantId) {
            var productId = this.variants[variantId].productId;
            if(!!this.products[productId].quantity_interval){
                var interval= this.products[productId].quantity_interval.split("|");
            }else{
                var interval="|".split("|")
            }
            return [parseInt(interval[0]), parseInt(interval[1])];
        },
        getQuantityMaxperdayByVariantId:function(variantId){
            console.trace(this)
            var productId = this.variants[variantId].productId;
            var product = this.products[productId];
            var qtyMax = undefined
            if (!!product.max_per_day && product.max_per_day !== "-1") {
                qtyMax = product.max_per_day - (product.kept_quantity[this._.filtre.date]===undefined?0:product.kept_quantity[this._.filtre.date]);
            }
            return qtyMax;
        },
        getQuantityMaxperdayByCartItem:function(data){
            var qtyMax = 100000
            var intervals = data.properties._interval
            var intervalMax = undefined
            if(!!intervals && !!intervals[1]){
                intervalMax = intervals[1]
            }
            var maxperday=data.properties._maxperday || undefined
            if(!!maxperday){
                maxperday=parseInt(maxperday)
            }
            if(!!maxperday && maxperday!== -1 && maxperday!== 0 && !!intervals && !!intervalMax && intervalMax!== 'NaN'  && maxperday!== 'NaN'){
                qtyMax = maxperday <= intervalMax? maxperday:intervalMax
            }
            else if(!!maxperday && maxperday !== 0 && maxperday!== -1){
                qtyMax = maxperday
            }
            else if(!!intervals && !!intervalMax && maxperday !== 'NaN'){
                qtyMax = intervalMax
            }
            return qtyMax
        },

        //--- action sur les boutons pour le produits
        onInputProductQuantity: function (evt) {
            var qty = $(evt.target).val() || 0
            this.changeProductQuantity($(evt.target), qty <= 0 ? 0 : qty , "input");
        },
        onPlusProductQuantity: function (evt) {
            if(CartJS.cart.item_count === 0) {
                this.emit('unemptyCart');
                $('.js-announcement-bar').removeClass('is-closed');
            }
            var $quantityInput = $(evt.target).closest(this._.selectors.productBlock).find(this._.selectors.quantityInput);
            var variantId = $quantityInput.attr('data-variant');
            if(!this.bufferQty || !this.bufferQty[variantId]){
                this.bufferQty= Object.assign(this.bufferQty,{ [variantId] : (parseInt($quantityInput.val() || 0) + 1)})
            }else{
                this.bufferQty= Object.assign(this.bufferQty,{ [variantId] : (this.bufferQty[variantId] + 1)})
            }
            this.changeProductQuantity($quantityInput, this.bufferQty[variantId],"plus");
        },
        onMinusProductQuantity: function (evt) {
            var $quantityInput = $(evt.target).closest(this._.selectors.productBlock).find(this._.selectors.quantityInput);
            var variantId = $quantityInput.attr('data-variant');
            var qtyMinus =(!this.bufferQty || !this.bufferQty[variantId])?(parseInt($quantityInput.val() || 0) - 1):(this.bufferQty[variantId] - 1)

            if(qtyMinus!==0){
                this.bufferQty = Object.assign(this.bufferQty,{ [variantId] : qtyMinus})
            }else{
                delete this.bufferQty[variantId];
            }

            this.changeProductQuantity($quantityInput,qtyMinus, "minus");
        },
        changeProductQuantity: function ($input, targetQuantity, type) {

            var originQuantity    = $input.val() || 0;

            if(type !== "input"  && originQuantity === targetQuantity || targetQuantity < 0) { return; }

            var variantId    = $input.attr('data-variant');
            if(!!variantId){
                //bloquer les autres bouton pour le tps d'enregistrer la bonne valeur dans le panier
                this.disableBlocBuy(variantId)
            }
            var tags   = $input.attr('data-tags');
            var vendor = $input.attr('data-vendor');
            originQuantity = parseInt(originQuantity);
            targetQuantity = parseInt(targetQuantity);

            var datas =  {
                variant_id: variantId,
                quantity: targetQuantity,
                vendor: vendor,
                properties: {
                    _originQuantity:originQuantity,
                    _maxperday: this.getQuantityMaxperdayByVariantId(variantId),
                    _interval: this.getProductInterval(variantId),
                    _vendor : vendor,
                    _deposit: _.includes(tags,"_DEPOSIT"),
                    _is_tt: _.includes(tags,"_is_tt"),
                    _is_magic: _.includes(tags,"_CHILD_PRICE") || _.includes(tags,"_FREE_PRICE")
                }};

            var returnData = Object.assign(datas,{quantity:TT.getQuantityForChange(datas)})
            if(returnData.quantity===0){
                delete this.bufferQty[variantId]
            }else{
                this.bufferQty[variantId]=returnData.quantity
            }
            this.renderQtyForms(returnData)

            $(".form__btn").attr("disabled","disabled");
            $(".product-row-qty-"+type+"[data-variant='"+variantId+"']").removeAttr("disabled")

            $(".cart__qty-adjust").attr("disabled","disabled");
            $(".js-qty__adjust--"+type+"[data-variant='"+variantId+"']").removeAttr("disabled")

            console.log("%cRUN SCLayoutProducts.changeProductQuantity","background:orange;color:#333")
            this.emit('changeProductQuantity',datas);

        },
        razInput : function(variantID){
            this.renderQtyForms({variant_id:parseInt(variantID),quantity:0,properties:{_interval:"|"}})
        },
        renderQtyForms:function(data){
            var qty = parseInt(TT.getQuantityForChange(data))
            var qtyMax = parseInt(this.getQuantityMaxperdayByCartItem(data))
            var vid = data.variant_id
            var $element_InputQty = this.getProductQuantityInput(vid)
            var $element_ImgQty = this.getProductQuantityImg(vid)
            var $element_MinusBtn = this.getProductQuantityMinus(vid)
            var $element_PlusBtn = this.getProductQuantityPlus(vid)

            $element_PlusBtn.removeClass("lock")
            if(qtyMax === qty){
                $element_PlusBtn.addClass("lock")
            }

          //  console.log({bloc:this.getProductContainer(vid)})
            $element_InputQty.attr('data-quantity', qty).val(qty).trigger('change');

            // conflit page detail du produit pour les PM et MV
            this.getProductContainer(vid).attr('data-quantity', qty);


            $element_ImgQty.text(qty)

            $element_MinusBtn.toggleClass('disabled', qty === 0)
            $element_InputQty.toggleClass('disabled', qty === 0)
            $element_PlusBtn.toggleClass('disabled', qty >= qtyMax)

            //pour afficher la bull et le bouton voir le panier sur les modals et page solo
            if(TT.countProducts > 0){
                $(".js-see-cart").removeClass("hidden")
            }else{
                $(".js-see-cart").addClass("hidden")
            }
        },
        refreshQtyForms:function(evt,name,data){
            console.log("%cRUN SCLayoutProducts.renderFormQty","background:orange;color:#333")
            var vid = data.variant_id
            var qty = data.quantity

            if(qty===0){
                delete this.bufferQty[vid]
            }else{
                this.bufferQty[vid]=qty
            }
            var $element_InputQty = this.getProductQuantityInput(vid)
            if(!$element_InputQty.length) { return; }

            this.renderQtyForms(data)
            this.enableBlocBuy()
        },

        onMouseOverModalProduct:function (evt){
            var el = $(evt.currentTarget)
            var productId =el.attr("data-product-id")
            var collectionId=el.attr("data-collection-id")

            if(!productId || !collectionId){
                //  console.error({el:evt,productId,collectionId})
            }else{
                console.log({QuickShopModal:"#QuickShopModal-"+productId+"_"+collectionId})
                $("#QuickShopModal-"+productId+"_"+collectionId)
                //special theme.js
                theme.preloadProductModal(this.vendors[collectionId].products[productId].handle, productId, collectionId, undefined)

            }
        },
        checkModalReload:function(evt,data){
            this.modalReload.push(data.modalId)
        },
        reloadAllModal:function(){
            Object.values(this.vendors).map((vendor)=>
                Object.values(vendor.products).map((product)=>
                    theme.preloadProductModal(product.handle, product.id,vendor.id, undefined)
                )
            )
        },
        closeAllModal:function(evt){
            var el = $(evt.currentTarget)
            $('.js-modal-close').click()
            $(".js-filtre-overlay").hide();
            if(el.attr("data-url")!=undefined){
                console.log({url:el.attr("data-url")})
                window.location = el.attr("data-url")
            }
        },
        openSlideModal:function(evt){
            var el = $(evt.currentTarget)

            var productId =el.attr("data-product-id")
            var collectionId=el.attr("data-collection-id")
            if(!productId || !collectionId){
                return null
            }
            console.log({QuickShopModal:"#QuickShopModal-"+productId+"_"+collectionId})
            theme.instModals["QuickShopModal-"+productId+"_"+collectionId].open();
        },


        debugBtnQty:function(){
            $(".js-prod-tt-ko").css("background-color","red")
            $(".js-prod-tt-ok").css("background-color","green")
            // $(".js-prod-nott-ok").css("background-color","orange")
        },
        searchSideProducts(pid,cid){
            var sortProduct = Object.values(this.vendors[cid]["sort"]);
            var lenghtProd= sortProduct.length
            var dispoProduct =this.dispoProduct[cid];
            var posCurrent = sortProduct.indexOf(pid)

            var idProdPrev = sortProduct[posCurrent-1]

            if(!!idProdPrev && !dispoProduct[idProdPrev] ){
                //  console.log({msg:"f1",idProdPrev,cond:!!idProdPrev && !dispoProduct[idProdPrev]})
                idProdPrev=undefined
                for (var cptPrev=(posCurrent-1);cptPrev>=0;cptPrev--){
                    idProdPrev = sortProduct[cptPrev]
                    //  console.log({msg:"f2",cptPrev,idProdPrev,cond:!!idProdPrev && !dispoProduct[idProdPrev]})
                    if(!!idProdPrev && !!dispoProduct[idProdPrev]){
                        break
                    }
                    idProdPrev=undefined
                }
            }

            var idProdNext= sortProduct[posCurrent+1]
            if(!!idProdNext && !dispoProduct[idProdNext] ){
                //     console.log({msg:"f1",idProdNext,cond:!!idProdNext && !dispoProduct[idProdNext]})
                idProdNext=undefined
                for (var cptNext=(posCurrent+1);cptNext<lenghtProd;cptNext++){
                    idProdNext = sortProduct[cptNext]
                    // console.log({msg:"f2",cptNext,idProdNext,cond:!!idProdNext && !dispoProduct[idProdNext]})
                    if(!!idProdNext && !!dispoProduct[idProdNext]){
                        break
                    }
                    idProdNext=undefined
                }
            }

            return [idProdPrev,idProdNext]
        },
        updateBtnModalSlide:function(datas){

            ///TODO a optimiser que pour 1 produit...
            this.searchProductAvailability()

            //actualise la QTY de me la modal
            if(!datas.cid && !datas.pid ){
                return false
            }

            if( typeof scListCollections === 'object' ){
                var dataCart = TT.getProduct(scListCollections.products[datas.pid].variantId)
            }else{
                var dataCart = TT.getProduct(scProductDetail.products[datas.pid].variantId)
            }
            if(!!dataCart){
                this.renderQtyForms(dataCart)
            }

            //   console.log({method:"SC updateBtnModalSlide",datas})
            this.emit("updateModal",datas)
            // datas: cid: "272502784164", pid: "6778305216676"
            //ajouter les bonne classe
            //js-modal js-modal-close js-modal-open-quick-modal-6782123802788
            // $(".js-modal-slide-next")
            if(!datas.cid ){
                return false
            }

            var idModal = datas.pid+"_"+datas.cid

            var [idProdPrev,idProdNext] =  this.searchSideProducts(datas.pid,datas.cid)


            if(!!idProdPrev){
                $("#QuickShopModal-"+idModal).find(".js-modal-slide-prev").removeClass("hide")
                $("#QuickShopModal-"+idModal).find(".js-modal-slide-prev").attr("data-product-id",idProdPrev)
                $("#QuickShopModal-"+idModal).find(".js-modal-slide-prev").addClass("js-modal-open-quick-modal-"+idProdPrev+"_"+datas.cid)

                $("#QuickShopModal-"+idModal).find(".js-modal-slide-prev").attr("data-product-id",idProdPrev)
                $("#QuickShopModal-"+idModal).find(".js-modal-slide-prev").attr("data-collection-id",datas.cid)

                $("#QuickShopModal-"+idModal).find(".js-modal-slide-prev").attr("data-gtm-produit",scListCollections.products[idProdPrev].title.replaceAll('"',"'").replaceAll("__",","))
                //console.log({idProdPrev,"event":this.vendors[datas.cid].products[idProdPrev]})
                // theme.preloadProductModal(this.vendors[datas.cid].products[idProdPrev].handle, idProdPrev, datas.cid, undefined)

            }else{
                $("#QuickShopModal-"+idModal).find(".js-modal-slide-prev").addClass("hide")
            }

            //special bouton droit si le produit current et _is_tt et pas attribute ds cartjs  'je ne l afficha pas' demande apres l ajout du filtre de la modal
            var show_btn_right = true;
            if(this.products[datas.pid].tags.indexOf("_is_tt")!==-1 && TT.ProductisTT.length === 0 ){
                show_btn_right = false
            }

            if(!!idProdNext && show_btn_right){
                $("#QuickShopModal-"+idModal).find(".js-modal-slide-next").removeClass("hide")
                $("#QuickShopModal-"+idModal).find(".js-modal-slide-next").attr("data-product-id",idProdNext)
                $("#QuickShopModal-"+idModal).find(".js-modal-slide-next").addClass("js-modal-open-quick-modal-"+idProdNext+"_"+datas.cid)

                $("#QuickShopModal-"+idModal).find(".js-modal-slide-next").attr("data-product-id",idProdNext)
                $("#QuickShopModal-"+idModal).find(".js-modal-slide-next").attr("data-collection-id",datas.cid)
                $("#QuickShopModal-"+idModal).find(".js-modal-slide-next").attr("data-gtm-produit",scListCollections.products[idProdNext].title.replaceAll('"',"'").replaceAll("__",","))
                //console.log({idProdNext,"event":this.vendors[datas.cid].products[idProdPrev]})
                //theme.preloadProductModal(this.vendors[datas.cid].products[idProdNext].handle, idProdNext, datas.cid, undefined)
                //theme.instModals["QuickShopModal-"+idProdNext+"_"+datas.cid]._open()
            }else{
                $("#QuickShopModal-"+idModal).find(".js-modal-slide-next").addClass("hide")
            }


            // console.log("RUN QuickShopModal")
            //  console.log({datas})

        },
        onRedirectExternalProduct:function(event){
            var external_link =  $(event.currentTarget).attr("data-link");
            window.location = external_link;
        },
        renderBtnSideProduct:function(){
            if($(".js-product-main").length !== 1 ){
                return []
            }
            var pid = $(".js-product-main").attr("data-product-id")
            var cid = $(".js-product-main").attr("data-collection-id")
            if(!cid){
                return []
            }
            var [idProdPrev,idProdNext] =  this.searchSideProducts(pid,cid)
            console.log({idProdPrev,idProdNext})

            if(!!idProdPrev){
                $(".js-slider-button-mobile-prev").attr("href","/products/"+this.products[parseInt(idProdPrev)].handle+"?cid="+cid)
            }else{
                $(".js-slider-button-mobile-prev").addClass("hidden")
            }

            if(!!idProdNext){
                $(".js-slider-button-mobile-next").attr("href","/products/"+this.products[parseInt(idProdNext)].handle+"?cid="+cid)
            }else{
                $(".js-slider-button-mobile-next ").addClass("hidden")
            }

        },
        //bloquer les produits si d'autre produit d'un autre vendor est dans le panier
        disableNonVendorInputs: function (vendor) {
            /*  $(this._.selectors.quantityInput).each(_.bind(function (k, e) {
                  if(vendor && $(e).attr('data-vendor') !== vendor) {
                      this.unvalidateProduct($(e).attr('data-variant'), this._.messages.unvalidVendor)
                  } else {
                      this.validateProduct($(e).attr('data-variant'))
                  }
              }, this));*/
            console.log("%cRUN SCLayoutProducts.disableNonVendorInputs","background:orange;color:#333")
            $(this._.selectors.quantityInput).each(_.bind(function (k, e) {
                //  console.log($(e).attr('data-vendor'),vendor)
                if ((vendor && $(e).attr('data-vendor') !== vendor)) {
                    this.unvalidateProduct($(e).attr('data-variant'), this._.messages.unvalidVendor)
                }
                else if ($(e).closest(this._.selectors.quantityForm).hasClass('is-invalid-date')) {
                    this.unvalidateProduct($(e).attr('data-variant'), this._.messages.indispoDate)
                }
                else  {
                    this.validateProduct($(e).attr('data-variant'))
                }
            }, this));
        },

        //synchroniser les produits dans la liste par rapport au produit dans le panier
        synchronizeProductsDisplay: function (event, name, data) {
            console.log("%cRUN SCLayoutProducts.synchronizeProductsDisplay","background:green;color:white")
            if(!!data) {
                this.refreshQtyForms(null,null,data);
                this.bufferQty= Object.assign(this.bufferQty,{ [data.variant_id] : data.quantity})
            } else {
                _.each(TT.cart.items, _.bind(function (item) {
                    if(item.product_type !== 'Livraison') {
                        this.refreshQtyForms(null,null,item)
                        this.bufferQty= Object.assign(this.bufferQty,{ [item.variant_id] : item.quantity})
                    }
                }, this));
            }
        },

        //-- initiliser la variable "variants" par rapport au produit
        initVariantJS:function(){
            console.log("%cRUN SCLayoutProducts.initVariantJS","background:orange;color:#333")
            this.variants=[]
            if(!!this.vendor && !!this.vendor.products){
                //TODO verifier si produit magic et ajoute les variant en fonction de produit id
                for (var productId in this.vendor.products) {
                    var product =  this.vendor.products[productId]
                    if(!!product){
                        if(product.free_price !== ""){
                            for( kPM in product.products_magic){
                                var productMagicId = product.products_magic[kPM].id
                                //recuperer l id du produit principla pour les produit magique
                                this.variants[parseInt(product.variantId)] = { vendorId: parseInt(product.variantId ), productId: productId ,type:product.type,product_child:product.products_magic}

                                for(kPMV in product.products_magic[kPM].variants){
                                    var PMVariant = product.products_magic[kPM].variants[kPMV]
                                    this.variants[parseInt(PMVariant.id)] = { vendorId: parseInt(PMVariant.id), productId: productMagicId, product_parent: product.id  ,type:product.type,name:PMVariant.name, options:PMVariant.options,price:PMVariant.price}
                                }
                            }
                        }else{
                            if(product.variants.length > 1){
                                for( kMultiV in product.variants){
                                    var currentVariant = product.variants[kMultiV]
                                    this.variants[parseInt(currentVariant.id)] = { vendorId: parseInt(currentVariant.id ), productId: productId ,type:product.type,name:currentVariant.name, options:currentVariant.options,price:currentVariant.price}
                                }
                            }else{
                                var currentVariant = product.variants.first
                                this.variants[parseInt(product.variantId)] = { vendorId: parseInt(product.variantId ), productId: productId ,type:product.type,name:currentVariant.name, options:currentVariant.options,price:currentVariant.price}
                            }
                        }
                    }
                }

            }else if(!!this.vendors){
                var vendors = Object.values(this.vendors)
                for (var index in Object.values(this.vendors)) {
                    var vendor = vendors[index]
                    if(!!vendor.products){
                        for (var productId in vendor.products) {
                            var product =  vendor.products[productId]
                            if(!!product){
                                if(product.free_price !== ""){
                                    for( kPM in product.products_magic){
                                        var productMagicId = product.products_magic[kPM].id.toString()

                                        this.variants[parseInt(product.variantId)] = { vendorId: parseInt(product.variantId ), productId: productId ,type:product.type,product_child:product.products_magic}

                                        for(kPMV in product.products_magic[kPM].variants){
                                            var PMVariant = product.products_magic[kPM].variants[kPMV]
                                            this.variants[parseInt(PMVariant.id)] = { vendorId: parseInt(PMVariant.id), productId: productMagicId, product_parent: product.id ,type:product.type,name:PMVariant.name, options:PMVariant.options,price:PMVariant.price}
                                        }
                                    }
                                }else{
                                    if(product.variants.length > 1){
                                        for( kMultiV in product.variants){
                                            var currentVariant = product.variants[kMultiV]
                                            this.variants[parseInt(currentVariant.id)] = { vendorId: parseInt(currentVariant.id ), productId: productId ,type:product.type,name:currentVariant.name, options:currentVariant.options,price:currentVariant.price}
                                        }
                                    }else{
                                        var currentVariant = product.variants[0]
                                        this.variants[parseInt(product.variantId)] = { vendorId: parseInt(product.variantId ), productId: productId ,type:product.type,name:currentVariant.name, options:currentVariant.options,price:currentVariant.price}
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },

        //-- initiliser les variables generique pour les chefs ou le chefs recuperer sur la page
        initDatasVendor:function(){
            console.log("%cRUN SCLayoutProducts.initDatasVendor","background:orange;color:#333")

            if(!window.chefsJS){
                console.log("Erreur la variable ChefsJS n'est pas valide");
                return false;
            }

            //   this.deliveryProducts =[]
            this.sortProductType=[] //aucun liste ordre type produit
            this.products={}
            this.types ={}
            this.vendors=[];
            this.vendor_ids =[]
            this.countProduct=0
            //remise a zero l object type de produit
            _.each(this.sortProductType, _.bind(function (type) {
                if(!this.types[type]){
                    this.types[type]=[]
                }
            }, this))

            //initialiser les produits et les vendors

            _.each(chefsJS, _.bind(function (chefJS) {
                this.products= _.merge( this.products,chefJS["products"])
                this.vendors[chefJS['id']] = chefJS
                //  this.deliveryProducts[chefJS.livraison.vendor] = chefJS.livraison
                this.vendor_ids.push(parseInt(chefJS['id']))
            }, this))

            //initialisation les produit magic
            _.each(this.products, _.bind(function (prod) {
                if(prod.tags.includes("_FREE_PRICE")){
                    for (kPM in prod["products_magic"]){
                        var prodTmp = _.merge(prod["products_magic"][kPM],{"productMain":prod["id"]})
                        this.products= _.merge( this.products,{[prod["products_magic"][kPM].id]:prodTmp})
                    }
                }

            }, this))

            this.countProductShow=0;
            this.countProductHide=0;
            this.countProduct += Object.keys(this.products).length

            /*  if(Object.keys(chefsJS).length>1){
             }
             else{
                 var chefJS = Object.values(chefsJS).shift();
                 this.products = chefJS.products;
                 this.countProduct = Object.values(this.products).length;
                 this.types = chefJS.product_type;
                 this.vendor = chefJS;
                 if(!!chefJS.livraison.vendor){
                     this.deliveryProducts[chefJS.livraison.vendor] = chefJS.livraison
                 }
                 this.vendor_id = this.vendor.id;

             }*/

        },

        //-- recuperer les informations lier au panier qui a ete envoyer du filtre au controller
        getDatasFiltre:function(){

            var attrTime = TT.cart.attributes.Heure
            if(!!attrTime && attrTime.includes("-")){
                attrTime = attrTime.replace(" ","").split("-")[0].split(":")[0];
            } else if(!!attrTime && attrTime.includes(":")){
                attrTime = attrTime.split(":")[0];
            }
            var attrDate = TT.cart.attributes.Date;
            var attrDatetime= null;
            var attrDay= null;
            if(!!attrDate && attrTime){
                attrDatetime= _TOOLS.strToDate(attrDate, attrTime);
                attrDay= this._.day_index[attrDatetime.getDay()];
            }
            this._.filtre={
                deliveryType :TT.cart.attributes._deliveryType,
                date : TT.cart.attributes.Date,
                time : attrTime,
                datetime : attrDatetime,
                day : attrDay
            }
            return this._.filtre;
        },

        //verfier si la date de livraison est bonne  si pickup toujour valid
        isDateDeliveryValid:function(){
            // que pour la livraison
            if (this._.filtre.deliveryType === "delivery") {
                var dateDelivery = this._.filtre.datetime;
                var now = new Date();
                now.setHours(parseInt(this._.filtre.time), 00, 00, 00);
                var tomorrow = new Date();
                tomorrow.setDate(now.getDate() + 1);
                var hourNow = new Date().getHours();

                // pas de livraison pour le jour d'après apres 18h
                if (hourNow >= scFilterMenu.maxOrderHour) {
                    if (dateDelivery.getTime() === tomorrow.getTime()) {
                        return false;
                    }
                }
            }
            return true;
        },
        //verfier si un chef est disponible
        isChefDispoValid: function (chefId) {
            //    console.log({chefId,vendors:!!this.vendors[chefId],isChefDateDispoValid:this.isChefDateDispoValid(chefId)})
            return !!this.vendors[chefId] && this.isChefDateDispoValid(chefId)
            //  && this.isChefZipDispoValid(chefId)
        },

        isChefDateDispoValid: function(chefID){

            //     console.log({filtre:this._.filtre})

            if(this._.filtre === undefined ){
                return true;
            }

            var vendor = this.vendors[chefID];


            //  console.log({chefID,filtre:this._.filtre,vendor})

            // verification si le chef est fermer par des intervalle de date
            //  console.log({closed_dates:vendor.closed_dates , cond:!!vendor.closed_dates})
            if(!!vendor.closed_dates){
                var closed_dates_chef = ((vendor.closed_dates) || '').split(',');
                var is_closed_dates = false;
                for(var i = 0; i < closed_dates_chef.length; i++) {
                    //    console.log({filtre:this._.filtre.date, closed_dates_chef:closed_dates_chef[i]})
                    is_closed_dates = is_closed_dates || _TOOLS.isIntervalDate(this._.filtre.date, closed_dates_chef[i])
                }
                if(is_closed_dates) { return false; }
            }

            var typeOrder = this._.filtre.deliveryType;
            var dayOrder = this._.day_index[this._.filtre.datetime.getDay()];

            //juste pour verifier si le chef travail le matin ou le midi  => timeDispo.includes(convertHourTotimeService(hourOrder))
            //ajout de la condition si il travail le jour meme

            var dateNow = new Date();
            var hourNow = dateNow.getHours();
            var hourOrderInt= parseInt(this._.filtre.time);
            if(typeOrder === "delivery"){
                hourOrderInt=hourOrderInt + 1;//pour gerer les ecart 12h-14h donc je prend 13h car le int c 12
            }
            //   console.log({cond:!vendor.disponibility,vendor,filtre: this._.filtre})
            if(!vendor.disponibility){
                console.error("Manque la disponibility dans chefsJS")
            }

            var hourDispo = (!!vendor.disponibility[typeOrder] && !!vendor.disponibility[typeOrder][dayOrder])?vendor.disponibility[typeOrder][dayOrder]:[];
            //  console.log({disponibility:vendor.disponibility,hourDispo,typeOrder,dayOrder})
            if(!hourDispo){
                return false;
            }
            //si les dates sont identique est que l on a parametrer le jour J  scFilterMenu.initMinDate!=0
            if(_TOOLS.dateToStr(dateNow) === this._.filtre.date) {
                //si on peu commander le jour J et que la date a un bon ecart on valide si heure existe dans la liste des heur dispo pour le vendor
                if(scFilterMenu.initMinDate===0 && (hourOrderInt - hourNow) >= scFilterMenu.ecartHour && scFilterMenu.ecartHour!=0){
                    return hourDispo.includes(hourOrderInt.toString());
                }
                return false;
            } else {
                return hourDispo.includes(hourOrderInt.toString());
            }
        },

        //--change affichage du form quantity
        //--gestion du blocage des produits formulaire d'ajout
        unvalidateAllProducts: function(message){
            if(message === undefined){
                message=this._.messages.unvalidFilters;
            }
            $(this._.selectors.quantityInput).each(_.bind(function (k, e) {
                this.unvalidateProduct($(e).attr('data-variant'),message)
            }, this));
        },
        validateAllProducts: function(){
            $(this._.selectors.quantityInput).each(_.bind(function (k, e) {
                this.validateProduct($(e).attr('data-variant'))
            }, this));
        },
        unvalidateProduct(variant_id, reason) {
            // console.log({variant_id, reason})
            // ajouter btn faux ajout
            this.emit("productUnvalid",{variant_id, reason})
            $("body").find('.js-modal-window[data-variant="' + variant_id + '"]').removeClass("hide")
            if (!!TT.validateFilterCartAttributes()){
                $('.js-product-bloc[data-variant="' + variant_id + '"]')
                    // .addClass("opacityProd").end()
                    .find(".js_modal_is_tt_ko").addClass('hide').end()
                    .find(this._.selectors.quantityPlusFakeButton).addClass('disabled');

            }else{
                $('.js-product-bloc[data-variant="' + variant_id + '"]')
                    .find(".js_modal_is_tt_ko").removeClass('hide').end()
                    .find(this._.selectors.quantityPlusFakeButton).removeClass('disabled')
            }

            $('.js-product-bloc[data-variant="' + variant_id + '"]')
                .find(this._.selectors.notOrderProduct).removeClass('hidden').text(reason).end()
                //special modal
                .find(".js_modal_is_tt_ok").addClass('hide').end()
                //.find(".js_modal_is_tt_ko").removeClass('hide').end()

                //effacer les champ ajout de qty et affiche le faux btn plus pour ouvrir la modal
                .find(this._.selectors.quantityPlusButton).addClass('disabled');

            // .find(this._.selectors.quantityForm).addClass('disabled');
        },
        validateProduct: function (variant_id) {
            //recuperer le produit id - correction pour les produits multi variants et les produit magic
            if(!this.variants[variant_id]){
                console.log("variant not exist into liste variants")
                return false
            }

            if(!!this.variants[variant_id].product_parent){
                var pid = this.variants[variant_id].product_parent;
            }else{
                var pid = this.variants[variant_id].productId;
            }

            if(!pid){
                console.log("variant not exist into liste variants")
                return false
            }

            $(this._.selectors.productBlock+'[data-variant="' + variant_id + '"]').removeClass("opacityProd");
            if (!!TT.validateFilterCartAttributes()) {
                $("body").find('.js-modal-window[data-pid="' + pid + '"]').addClass("hide")
                // $("body").find('.js-modal-window[data-variant="' + variant_id + '"]').addClass("hide")
            }else{
                $("body").find('.js-modal-window[data-pid="' + pid + '"]').removeClass("hide")
                // $("body").find('.js-modal-window[data-variant="' + variant_id + '"]').removeClass("hide")
            }
            
            $('.js-product-bloc[data-product-id="' + pid + '"]')
                .find(this._.selectors.notOrderProduct).addClass('hidden').end()
                //special modal
                .find(".js_modal_is_tt_ok").removeClass('hide').end()
                .find(".js_modal_is_tt_ko").addClass('hide').end()
                //effacer les champ ajout de qty et affiche le faux btn plus pour ouvrir la modal
                .find(this._.selectors.quantityPlusFakeButton).addClass('disabled').end()
                .find(this._.selectors.quantityPlusButton).removeClass('disabled');

            //.find(this._.selectors.quantityForm).removeClass('disabled');
        },
        //blocage tous les ajouts de produit sauf sur celui cliquer
        disableBlocBuy(exection_id){
            $('.js-cart-product').each(_.bind(function(index,el){
                var variant_id = $(el).attr('data-variant')
                if(parseInt(variant_id) !== parseInt(exection_id) && !$(el).find(this._.selectors.quantityForm).hasClass('waiting')){
                    $(el).find(this._.selectors.quantityForm).addClass('waiting')
                }
            },this))
        },
        enableBlocBuy(){
            $('.js-cart-product').each(_.bind(function(index,el){
                $(el).find(this._.selectors.quantityForm).removeClass('waiting')
            },this))
        },
        //-- gestion de l'affichage des produits
        hideCardProductAll: function () {
            if (!!TT.validateFilterCartAttributes()) {
                this.emit("productUnvalid")
                $("body").find('.js-modal-window').removeClass("hide")
                //  $(this._.selectors.productBlock).addClass("opacityProd");
                $(this._.selectors.notOrderProduct).removeClass('hidden').html(this._.messages.indispoDate)
            }else{
                $(this._.selectors.notOrderProduct).addClass('hidden').text("")
            }

            $([
                this._.selectors.quantityInput,
                this._.selectors.quantityMinusButton,
                this._.selectors.quantityPlusButton
            ].join(',')).removeAttr("disabled");

            //init les blockage des input qty
            //  $(this._.selectors.quantityForm).removeClass('disabled');
            $(".js_modal_is_tt_ko").toggleClass('hide', !!TT.validateFilterCartAttributes());
            $(this._.selectors.quantityPlusButton).addClass('disabled');
            $(this._.selectors.quantityPlusFakeButton).addClass('disabled');
        },

        showCardProductAll:function () {
            $(this._.selectors.productBlock).removeClass("opacityProd");
            // $(this._.selectors.quantityForm).removeClass('disabled');
            //$(this._.selectors.quantityPlusFakeButton).addClass('disabled');
            //$(this._.selectors.quantityPlusButton).removeClass('disabled');

        },

        //Special pour la page liste de produit de la page detail
        hideEmptySectionsTitle:function () {
            /*
                $(this._.selectors.typeBlock).each((index,element)=>{
                    if($(element).find(this._.selectors.productBlock+":visible").length === 0 ){
                        $(element).addClass("hidden");
                    }
                });
            */
        },
        showSectionsTitle:function () {
            /*
                $(this._.selectors.typeBlock).each((index,element)=>{
                    $(element).removeClass("hidden");
                });
            */
        },
        showCardProduct: function (productId) {
            var $elem = $(".js-product-" + productId);
            $elem.removeClass("opacityProd").show()
                .end().parent().prev(this._.selectors.productTitle).show()
                .end().find([this._.selectors.quantityInput, this._.selectors.quantityMinusButton, this._.selectors.quantityPlusButton].join(',')).removeAttr("disabled")

            //  console.log({productId,vendorId:this.products[productId].variantId,products:this.products})
            if(!!this.products[parseInt(productId)] && !!this.products[parseInt(productId)].variantId){
                // console.log(this.products[parseInt(productId)].variantId)
                this.validateProduct(this.products[parseInt(productId)].variantId)
            }
        },
        searchProductAvailability: function () {
            if(!this.dispoProduct){
                this.dispoProduct=[]
            }
            console.log("%cRUN SC.layout-products -> searchProductAvailability","background:orange;color:#333")
            this.hideCardProductAll();
            if (!TT.validateFilterCartAttributes()) {
                //verifier si le produit n'as pas _is_TT
                //this.unvalidateAllProducts();
                for (var indexChef in this.vendor_ids) {
                    var chefId = this.vendor_ids[indexChef]
                    var vendor = this.vendors[chefId]
                    this.dispoProduct[chefId]=[]
                    if(this.DEBUGLOG){
                        console.groupCollapsed();
                        console.log("%c=========================RUN "+vendor.title+" : "+chefId,"background:#88a6ab;color:white")
                        console.log({vendor})
                    }
                    for (var productId in vendor.products){
                        var productCurrent = this.products[productId]
                        if(productCurrent.tags.indexOf("_is_tt")===-1){
                            if(this.DEBUGLOG){
                                console.log({productCurrent})
                                console.log("%c---(NO _is_tt)-----RUN "+productCurrent.title+" : pid="+productId+" - vid="+productCurrent.variantId,"color:green")
                                console.log({productCurrent})
                            }
                            this.validateProduct(productCurrent.variantId)

                        }else{
                            if(this.DEBUGLOG) {
                                console.log("%c---(_is_tt)-----RUN " + productCurrent.title + " : " + productId, "color:blue")
                                console.log({productCurrent})
                            }
                            this.unvalidateProduct(productCurrent.variantId, this._.messages.unvalidFilters)
                            $(this._.selectors.notOrderProduct).addClass("hidden")
                        }
                        // afficher la modal apres meme si pas dispo
                        // console.log({tags:productCurrent.tags,istagssold:productCurrent.tags.indexOf("_soldout")===-1})
                        this.dispoProduct[chefId][productId] = productCurrent.tags.indexOf("_soldout") === -1;
                    }

                    if(this.DEBUGLOG) {
                        console.groupEnd();
                    }
                }
                return null;
            }

            for (var indexChef in this.vendor_ids) {
                var chefId = this.vendor_ids[indexChef]
                var vendor = this.vendors[chefId]

                if(this.DEBUGLOG) {
                    console.log("%c=========================RUN "+vendor.title+" : "+chefId,"background:#88a6ab;color:white")
                    console.groupCollapsed();
                    console.log({vendor})
                }
                this.dispoProduct[chefId]=[]

                var isDateDeliveryValid = this.isDateDeliveryValid();
                var isChefValid = this.isChefDispoValid(chefId);

                if(this.DEBUGLOG) {
                    console.log({isDateDeliveryValid, isChefValid})
                }
                var productId_dispo_date = [];
                var productId_dispo_stock = [];
                //pour chaque type de produit demander
                var productIdShowCollection = [];

                for (var productId in vendor.products) {
                    // toujours valid pour affocher la modal --   this.dispoProduct[chefId][productId]=false
                    this.dispoProduct[chefId][productId]=false
                    var productCurrent = this.products[productId]

                    //si c un produit items ne pas verifier
                    if (productCurrent && productCurrent.tags.includes("menu_item")) {  continue;  }
                    // console.log({TAGS: productCurrent.tags, cond:productCurrent.tags.indexOf("_is_tt")})
                    if(productCurrent.tags.indexOf("_is_tt") ===-1 ){
                        if(this.DEBUGLOG) {
                            console.log("%c---(NO _is_tt)-----RUN " + productCurrent.title + " : " + productId, "color:#8a00ff")
                            console.log({productCurrent})
                            console.log("%c   |--> isChefValid " + isChefValid, "background:orange;color:" + (isChefValid ? "green" : "red"))
                        }
                    }else{
                        if(this.DEBUGLOG) {
                            console.log("%c---(_is_tt)-----RUN " + productCurrent.title + " : " + productId, "color:#0051d4")
                            console.log({productCurrent})
                            console.log("%c   |--> isChefValid " + isChefValid, "color:white;background:" + (isChefValid ? "green" : "red"))
                        }
                        if (!isChefValid || !isDateDeliveryValid) { continue; }
                    }

                    if(this.DEBUGLOG) {
                        console.log("%c   |--> isDateDeliveryValid " + isDateDeliveryValid, "color:white;background:" + (isDateDeliveryValid ? "green" : "red"))
                    }

                    // verifier si le produit sont disponible dans l'intervalle
                    // que les produit TT car les non TT pas besoin du filtre pour les ajouter
                    var dateDispoProduct =  (productCurrent.tags.indexOf("_is_tt") !==-1 )? productCurrent.disponibility_dates:""
                    if (!!productCurrent && !!dateDispoProduct && dateDispoProduct !== "|") {
                        if (_TOOLS.isIntervalDate(this._.filtre.date, dateDispoProduct)) {
                            productId_dispo_date.push(productId)
                        }
                    } else {
                        productId_dispo_date.push(productId)
                    }

                    if(this.DEBUGLOG) {
                        console.log("%c   |--> isProductDispoDate " + (productId_dispo_date.includes(productId)), "color:white;background:" + (productId_dispo_date.includes(productId) ? "green" : "red"))
                    }
                    //verifier si il existe encore de stock pour le jour choisi
                    if (productCurrent && (!!productCurrent.kept_quantity[this._.filtre.date] && productCurrent.max_per_day !== -1)) {
                        if (productCurrent.kept_quantity[this._.filtre.date] < productCurrent.max_per_day) {
                            productId_dispo_stock.push(productId)
                        }
                    } else {
                        productId_dispo_stock.push(productId)
                    }

                    if(this.DEBUGLOG) {
                        console.log("%c   |--> isProductDispoStock " + (productId_dispo_stock.includes(productId)), "color:white;background:" + (productId_dispo_stock.includes(productId) ? "green" : "red"))
                    }
                }

                //recuperer les id en commun de productId_dispo_stock - productId_dispo_date
                var productIdShow = productId_dispo_date.filter(
                    (id) => productId_dispo_stock.indexOf(id) != -1
                )

                this.countProductShow = productIdShow.length
                this.countProductHide = this.countProduct - this.countProductShow

                if (this.countProductShow) {
                    for (var k in productIdShow) {
                        this.dispoProduct[chefId][productIdShow[k]]=true;
                        this.showCardProduct(productIdShow[k])
                    }
                }

                if(this.DEBUGLOG) {
                    console.groupEnd();
                }
            }
        },
        //render la liste des produits si viable
        render:function(){
            //init l affichage des quantités sur le champs input
            // $(".js-product-row-qty-input:not(.disabled)").val("")
            this.bufferQty={};
            console.log("%cRUN SC.layout-products -> render","background:orange;color:#333")

            //save dans le composant les variable du filtre
            this.getDatasFiltre();
            // this.validateAllProducts();
            //recuperation des information des information des produit dans le panier
            this.searchProductAvailability();

            this.synchronizeProductsDisplay()

            //$(".QuickShopHolder").html("")

        },
        onfilterChanged:function(){
            //  this.unvalidateAllProducts(this._.messages.submitFilters)
        },
        removeTTProducts:function(evt,name,data){

            console.log("%cRUN SC.removeTTProducts -> render","background:orange;color:#333")
            Object.keys(data).map((vid)=>{
                $(".js-product-row-qty-input[data-variant='"+vid+"']").val("")
                this.razInput(vid)
            })
            this.searchProductAvailability()
            this.synchronizeProductsDisplay()

        },

        changeVariantId:function(evt){

            //todo recuperer la qty dans le panier et  l ajouter dans le input
            var PMVariant = TT.getProduct(evt.currentTarget.value)
            var selectVariantPM = $(evt.currentTarget)
            var pmid = selectVariantPM.attr("data-pmid");

            $(".js-select-variant[data-pmid='"+pmid+"']").each((index,el)=>{
                //console.log(el)
                $(el).val(selectVariantPM.val());
                selectVariantPM = $(el)
                var formQty= selectVariantPM.parent()
                var BlockProduit= formQty.parent().parent().parent().parent()

                if(!!PMVariant){
                    formQty.find(".js-product-row-qty-input").val(PMVariant.quantity)
                    formQty.find(".js-product-row-qty-minus").removeClass("disabled")
                    formQty.find(".js-product-row-qty-input").removeClass("disabled")
                    if( $('#bloc_product_detail').length > 0){
                        $(".js-product-bloc").attr("data-quantity",PMVariant.quantity)
                    }else{
                        BlockProduit.attr("data-quantity",PMVariant.quantity)
                    }
                }else{
                    formQty.find(".js-product-row-qty-input").val(0)
                    formQty.find(".js-product-row-qty-minus").addClass("disabled")
                    formQty.find(".js-product-row-qty-input").addClass("disabled")
                    if( $('#bloc_product_detail').length > 0){
                        $(".js-product-bloc").attr("data-quantity",0)
                    }else{
                        BlockProduit.attr("data-quantity",0)
                    }
                }

                formQty.find(".js-product-row-qty-minus").attr("data-variant",evt.currentTarget.value)
                formQty.find(".js-product-row-qty-plus").attr("data-variant",evt.currentTarget.value)
                formQty.find(".js-product-row-qty-input").attr("data-variant",evt.currentTarget.value)
                BlockProduit.find(".js-product-row-qty-img").attr("data-variant",evt.currentTarget.value)

                if( $('#bloc_product_detail').length > 0){
                    $(".js-product-bloc").attr("data-variant",evt.currentTarget.value)
                }else{
                    BlockProduit.attr("data-variant",evt.currentTarget.value)
                }

            });
            if(!!PMVariant){
                this.renderQtyForms(PMVariant)
            }
            //todo penser aussi a la version modal
        },
        bindEvents:function(){
            $("body")
                .off("change.selectVariant").on("change.selectVariant",".js-select-variant",_.bind(this.changeVariantId,this))
                //   .off("blur.InputQty").on("blur.InputQty", this._.selectors.quantityInput, _.bind(this.onInputProductQuantity, this))
                .off("keyup.InputQty").on("keyup.InputQty", this._.selectors.quantityInput, _.bind(this.onInputProductQuantity, this))
                //  .off("change.InputQty").on("change.InputQty", this._.selectors.quantityInput, _.bind(this.onInputProductQuantity, this))

                .off("click.PlusQty").on("click.PlusQty", this._.selectors.quantityPlusButton, _.bind(this.onPlusProductQuantity, this))
                .off("click.MinusQty").on("click.MinusQty", this._.selectors.quantityMinusButton, _.bind(this.onMinusProductQuantity, this))

                // .off("mouseover.modalSlideNext").on("mouseover.modalSlideNext", this._.selectors.modalSlideNext, _.bind(this.onMouseOverModalProduct, this))
                //  .off("mouseover.modalSlidePrev").on("mouseover.modalSlidePre", this._.selectors.modalSlidePrev, _.bind(this.onMouseOverModalProduct, this))
                // .off("mouseover.modalSlide").on("mouseover.modalSlide",".js-product-bloc", _.bind(this.onMouseOverModalProduct, this))

                .off("click.modalSlideNext").on("click.modalSlideNext", ".js-modal-slide-next", _.bind(this.openSlideModal, this))
                .off("click.modalSlidePrev").on("click.modalSlidePrev", ".js-modal-slide-prev", _.bind(this.openSlideModal, this))
                .off("click.closemodal").on("click.closemodal", ".js-modal-return-close", _.bind(this.closeAllModal, this))
                .off("click.product_external_link").on("click.product_external_link", this._.selectors.productExternalBlock, _.bind(this.onRedirectExternalProduct, this))

            $(document)
                .on('TT.filtersValidated', _.bind(this.render, this))
                .on('TT.clearCart',_.debounce( _.bind(this.render, this), TT._.debounceTimeValue))
                .on('TT.removeTTProducts',_.debounce( _.bind(this.removeTTProducts, this), TT._.debounceTimeValue))

                .on('TT.itemCartUpdated', _.bind(this.synchronizeProductsDisplay, this))
                .on('TT.refreshQty', _.bind(this.synchronizeProductsDisplay, this))
                .on('TT.openBtnQty',_.bind(this.openBtnQty,this))
                // TODO revoir cette event dans le TT   si une action externe c le TT qui renvoi les instrtuctions
                .on('THEME.getNewCollectionContent', _.bind(this.init, this))
                .on('THEME.modalOpen', _.bind((e,data)=>this.updateBtnModalSlide(data), this))
                .on('THEME.preloadProductModal', _.bind(this.checkModalReload, this))

        },
        openBtnQty:function(){
            //$(".cart__qty-adjust").removeAttr("disabled","disabled");
            $(".form__btn").removeAttr("disabled");
        },
        init:function(){
            this.DEBUGLOG=false
            console.log("%cSTART SC.layout-products","background:cyan;color:#333")
            //recuperer le txt du cutomize
            if(!!indispoDate && indispoDate!==""){
                this._.messages.indispoDate = indispoDate;
            }
            this.bindEvents();
            this.initDatasVendor();
            this.initVariantJS();
            this.render()

            if($(".js-slider-button-mobile").length > 1){
                this.renderBtnSideProduct()
            }

            this.modalReload=[]
            $('.js-select-variant').trigger('change');
            // this.synchronizeProductsDisplay()
            // this.getDatasFiltre()
            /*  if(!!TT.vendor && !!TT.deliveryProduct){
                  if(Object.values(this.deliveryProducts).length === 1){
                      deliveryProduct = Object.values(this.deliveryProducts).shift() ;
                  }else if(Object.values(this.deliveryProducts).length > 1){
                      deliveryProduct = this.deliveryProducts[TT.vendor];
                  }else{
                      //exceptionnelle pour cadeau et list
                      deliveryProduct = TT.deliveryProduct;
                  }
              }
              */
        }
    }
    SCLayoutProducts.prototype= _.merge(SCLayoutProducts.prototype,_SCLayoutProducts);
    console.log("%cRENDER SC.layout-products","background:yellow;color:#333")

}
